<template>
  <div id="contrato-data">
    <v-layout>
      <v-flex xs12 md6>
        <!-- lo saque del siguiente campo  @focusout="checkUsername" -->
        <v-text-field
          v-model="codigo"
          :error-messages="codigoErrors"
          label="Codigo"
          required
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.codigo.$touch()"
          @blur="tipeView == 'crear' ? $v.codigo.$touch() : null"
        ></v-text-field>

        <v-text-field
          v-model="descripcion"
          :error-messages="descripcionErrors"
          label="Descripcion"
          required
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.descripcion.$touch()"
          @blur="tipeView == 'crear' ? $v.descripcion.$touch() : null"
        ></v-text-field>

        <v-text-field
          v-model="estado"
          :error-messages="estadoErrors"
          label="Estado"
          required
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.estado.$touch()"
          @blur="tipeView == 'crear' ? $v.estado.$touch() : null"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :box="isDisabled"
              :readonly="isDisabled"
              v-model="fechaReunion"
              label="Fecha reunion inicial"
              prepend-icon="event"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaReunion"
            no-title
            @input="menu1 = false"
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fechaInicio"
              label="Fecha inicio"
              prepend-icon="event"
              :box="isDisabled"
              :readonly="isDisabled"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaInicio"
            no-title
            @input="menu2 = false"
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="fechaFin"
              label="Fecha termino"
              prepend-icon="event"
              :box="isDisabled"
              :readonly="isDisabled"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fechaFin"
            no-title
            @input="menu3 = false"
            locale="es"
            first-day-of-week="1"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6></v-flex>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import axios from "axios";
import { error } from "util";
export default {
  name: "contrato-data",
  components: {},
  mixins: [validationMixin],
  props: {
    tipeView: "",
    contratoId: "",
  },
  data() {
    return {
      btnHidden: false,
      allowSpaces: false,
      fechaReunion: new Date().toISOString().substr(0, 10),
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      codigo: "",
      contratoId: "",
      descripcion: "",
      estado: "",
    };
  },

  mixins: [validationMixin],
  validations: {
    codigo: { required },
    descripcion: { required },
    estado: { required },
  },

  created() {
    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoIdStored;
      this.tipeView = this.$store.getters.tipeViewStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
      this.tipeView = this.$route.params.tipeView;
      this.$store.commit("contratoId_state", this.contratoId, this.tipeView);
    }
    if (this.tipeView == "consulta") {
      this.btnHidden = true;
    } else {
      this.btnHidden = false;
    }
  },
  mounted() {
    //llamar a la api de contratos para listar contratos
    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadData();
    }
  },
  computed: {
    codigoErrors() {
      const errors = [];
      if (!this.$v.codigo.$dirty) return errors;
      !this.$v.codigo.maxLength &&
        errors.push("Name must be at most 10 characters long");
      !this.$v.codigo.required && errors.push("Name is required.");
      return errors;
    },
    descripcionErrors() {
      const errors = [];
      if (!this.$v.descripcion.$dirty) return errors;
      !this.$v.descripcion.maxLength &&
        errors.push("Rut must be at most 10 characters long");
      !this.$v.descripcion.required && errors.push("Rut is required.");
      return errors;
    },
    estadoErrors() {
      const errors = [];
      if (!this.$v.estado.$dirty) return errors;
      !this.$v.estado.maxLength &&
        errors.push("Nombre must be at most 10 characters long");
      !this.$v.estado.required && errors.push("Nombre is required.");
      return errors;
    },
    fechaInicioErrors() {
      const errors = [];
      if (!this.$v.fechaInicio.$dirty) return errors;
      !this.$v.fechaInicio.maxLength &&
        errors.push("Nombre must be at most 10 characters long");
      !this.$v.fechaInicio.required && errors.push("Nombre is required.");
      return errors;
    },
    fechaFinErrors() {
      const errors = [];
      if (!this.$v.fechaFin.$dirty) return errors;
      !this.$v.fechaFin.maxLength &&
        errors.push("Nombre must be at most 10 characters long");
      !this.$v.fechaFin.required && errors.push("Nombre is required.");
      return errors;
    },
    isDisabled() {
      if (this.tipeView && this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
    },

    async loadContratoData() {
      var that = this;
      return await axios
        .get("/contrato/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadData() {
      this.contrato = await this.loadContratoData();
      this.codigo = this.contrato.codigo;
      this.descripcion = this.contrato.descripcion;
      this.estado = this.contrato.estado;
      this.fechaInicio = this.contrato.fechaInicio;
      this.fechaFin = this.contrato.fechaFin;
    },

    back() {
      setTimeout(() => {
        this.$store.state.route.from.fullPath;
      }, 1000);
    },
    loadContratos() {},
  },
};
</script>
